/**
 * Parts and maintenance slider initialization
 * Depends on: product-slider-chevrons.js
 */
(function() {
  const SELECTOR = '[data-parts-maintenance-slider]';
  
  const initPartsMaintenanceSliders = () => {
    if (!window.ProductSliderChevrons) return;
    window.ProductSliderChevrons.initAll(SELECTOR, document, { initHorizontalSlider: true });
  };
  
  document.addEventListener('DOMContentLoaded', initPartsMaintenanceSliders);
  window.addEventListener('load', initPartsMaintenanceSliders);
})();